import {omitBy,isNil} from 'lodash';

const response = (data:any) => {
    return omitBy({
        ...data,
        batchNumber:data.batchNumber,
        travellerName:data.travellerName,
        travellerNRIC:data.travellerNRIC,
        moValidateResult:data.moValidateResult,
        moRemark:data.moRemark,
    },isNil);
}

export default response;